/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Outcomeresponsenoreply3Inputs */

const en_outcomeresponsenoreply3 = /** @type {(inputs: Outcomeresponsenoreply3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No reply yet`)
};

const pt_outcomeresponsenoreply3 = /** @type {(inputs: Outcomeresponsenoreply3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ainda sem resposta`)
};

/**
* | output |
* | --- |
* | "No reply yet" |
*
* @param {Outcomeresponsenoreply3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const outcomeresponsenoreply3 = /** @type {((inputs?: Outcomeresponsenoreply3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Outcomeresponsenoreply3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_outcomeresponsenoreply3(inputs)
	return pt_outcomeresponsenoreply3(inputs)
});
export { outcomeresponsenoreply3 as "outcomeResponseNoReply" }